__turbopack_context__.v({
  "borderRoot": "_5v3ywW_borderRoot",
  "pl-plan-gradient-rotate": "_5v3ywW_pl-plan-gradient-rotate",
});
